import React from 'react';
import { Typography } from '@material-ui/core';
import { TFunction } from 'i18next';
import { ColumnProps } from 'components/@common/Table/LwtTable';
import { appendSecondsOrFallback, getDefaultText } from '../keyboarding-report-util';

const Title = ({ children }: any) => (
  <Typography style={{ fontSize: 12, fontWeight: 600 }}>{children}</Typography>
);

const getColumns: (
  t: TFunction
) => ColumnProps<{
  m1_timePerQuestion: any;
  m1_noOfTries: any;
  m2_timePerQuestion: any;
  m2_noOfTries: any;
  m3_timePerQuestion: any;
  m3_noOfTries: any;
}>[] = (t: TFunction) => {
  const main: ColumnProps<any> = {
    id: 'questionType',
    label: <Title>{t('Question Type')}</Title>,
    sortKey: 'questionType',
    getValue: item => <Typography>{item.questionType}</Typography>,
    sortable: true
  };

  return [
    main,
    {
      id: 'm1_timePerQuestion',
      label: <Title>{t('Avg. Time per Question')}</Title>,
      sortKey: 'm1_timePerQuestion',
      getValue: item => {
        return <Typography>{appendSecondsOrFallback(item.m1_timePerQuestion)}</Typography>;
      },
      sortable: true
    },
    {
      id: 'm1_noOfTries',
      label: <Title>{t('Avg. Tries per Question')}</Title>,
      sortKey: 'm1_noOfTries',
      getValue: item => <Typography>{getDefaultText(item.m1_noOfTries)}</Typography>,
      sortable: true
    },
    {
      id: 'm2_timePerQuestion',
      label: <Title>{t('Avg. Time per Question')}</Title>,
      sortKey: 'm2_timePerQuestion',
      getValue: item => <Typography>{appendSecondsOrFallback(item.m2_timePerQuestion)}</Typography>,
      sortable: true
    },
    {
      id: 'm2_noOfTries',
      label: <Title>{t('Avg. Tries per Question')}</Title>,
      sortKey: 'm2_noOfTries',
      getValue: item => <Typography>{getDefaultText(item.m2_noOfTries)}</Typography>,
      sortable: true
    },
    {
      id: 'm3_timePerQuestion',
      label: <Title>{t('Avg. Time per Question')}</Title>,
      sortKey: 'm3_timePerQuestion',
      getValue: item => <Typography>{appendSecondsOrFallback(item.m3_timePerQuestion)}</Typography>,
      sortable: true
    },
    {
      id: 'm3_noOfTries',
      label: <Title>{t('Avg. Tries per Question')}</Title>,
      sortKey: 'm3_noOfTries',
      getValue: item => <Typography>{getDefaultText(item.m3_noOfTries)}</Typography>,
      sortable: true
    }
  ];
};

export default getColumns;
